export type ReviewTransitionPhase = 'in' | 'out';

export const REVIEW_TRANSITION_MIN_HOLD_MS = 500;
export const REVIEW_TRANSITION_PAINT_MS = 90;
export const REVIEW_TRANSITION_FADE_OUT_MS = 320;

export function reviewTransitionReleaseDelay(startedAt: number, now: number = Date.now()): number {
  const holdRemaining = REVIEW_TRANSITION_MIN_HOLD_MS - Math.max(0, now - startedAt);
  return Math.max(REVIEW_TRANSITION_PAINT_MS, holdRemaining);
}

export default function ReviewTransition({ phase }: { phase: ReviewTransitionPhase }) {
  return (
    <div className={`review-transition review-transition--${phase}`} aria-hidden="true">
      <div className="review-transition__copy">
        <span className="review-transition__eyebrow" style={{ animationDelay: '40ms' }}>
          // Review
        </span>
        <span className="review-transition__line" style={{ animationDelay: '140ms' }}>
          Opening your review
        </span>
      </div>
    </div>
  );
}
